export const EXPERIMENT_ADD_TO_HOME_TIP = 'add-to-home-bookmark';
export const EXPERIMENT_USA_UNLIMITED_OFFER = 'usa-unlimited-offer';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_CONTROL = 'control';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_ONLY =
  'unlim-only';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_PLUS =
  'unlim-19-plus-12';
export const EXPERIMENT_INDIA_LOWER_PRICING = 'india-price-experiment';
export const EXPERIMENT_LOCKDOWN_RECIPIENT = 'lockdown-recipient';
export const FF_ADSERVER_MIGRATION = 'openx-ad-server-migration';
export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
